import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../_services/toast.service';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.css']
})
export class ToastNotificationComponent implements OnInit {

  private message: string;
  private title: string;

  constructor(private toast: ToastService) { }

  ngOnInit() {
    this.toast.getAlert().subscribe((alert) => {
      if (!alert) {
        // clear alerts when an empty alert is received
        return;
      }

      // add alert to array
      this.add(alert.color, alert.message, alert.title);
    });
  }

  add(color: string, message: string, title?: string) {
    setTimeout(function () {
      jQuery('#toasts').find('.message').addClass('bounceOutRight');
      setTimeout(function () {
        jQuery('#toasts').find('.message').css('z-index', '-10');
      }, 400);

    }, 3000);

    let status = 'green';
    if (color == 'green' || color == 'orange' || color == 'red') {
      status = color;
    }

    jQuery('#toasts').find('.message').removeClass('green red orange transition bounceOutRight hidden');
    jQuery('#toasts').find('.message').css('z-index', '9999');
    jQuery('#toasts').find('.message').addClass(`${status} bounceInRight`);

    this.title = title;
    this.message = message;
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/toast-notification/toast-notification.component.ts